import React from "react";

import { Icon, IconProps } from "../";

export const VideoOffIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M186.455929,1293.88262 L200.418056,1306.01972 C200.730667,1306.29147 200.763793,1306.76518 200.492044,1307.07779 C200.220296,1307.3904 199.746579,1307.42353 199.433968,1307.15178 L198.104479,1305.99732 C198.069878,1305.9991 198.035044,1306 198,1306 L188,1306 C186.895431,1306 186,1305.10457 186,1304 L186,1296 C186,1295.83637 186.01965,1295.67734 186.056718,1295.52512 L185.471841,1295.01469 C185.15923,1294.74294 185.126104,1294.26922 185.397853,1293.95661 C185.669601,1293.644 186.143318,1293.61088 186.455929,1293.88262 Z M205.800672,1296.11562 C205.930797,1296.31751 206,1296.55261 206,1296.79281 L206,1303.03894 C206,1303.7293 205.440356,1304.28894 204.75,1304.28894 C204.48493,1304.28894 204.226723,1304.20468 204.012677,1304.04832 L201.499874,1302.21265 L201.499874,1297.39965 L204.072809,1295.74213 C204.653079,1295.36813 205.42667,1295.53535 205.800672,1296.11562 Z M198,1294 C199.104569,1294 200,1294.89543 200,1296 L199.999874,1303.80565 L188.718874,1293.99965 L198,1294 Z"
        transform="translate(-184 -1288)"
      />
    </Icon>
  );
};
